"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _commonRichText = require("@mmc/common-rich-text");
var _commonCta = require("@mmc/common-cta");
var _text = require("@mmc/text");
var _header = _interopRequireDefault(require("../styles/header-350.css"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _header2 = _interopRequireDefault(require("./header-350.props/header-350.defaultProps"));
var _header3 = _interopRequireDefault(require("./header-350.props/header-350.propTypes"));
/**
 * ## Header350 - component
 *
 * A simple compact header component
 */

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp;
var Header350 = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Header350(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    Header350.renderHeadline = Header350.renderHeadline.bind(_this);
    Header350.renderParagraph = Header350.renderParagraph.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(Header350, _React$Component);
  Header350.resourceType = function resourceType() {
    return 'Header350_1_0_0';
  };
  Header350.ctaData = function ctaData(data) {
    return {
      url: handleNestedProp(data, 'data.url'),
      label: handleNestedProp(data, 'data.label'),
      priority: handleNestedProp(data, 'data.priority'),
      openNewTab: handleNestedProp(data, 'data.openNewTab'),
      icon: handleNestedProp(data, 'data.icon'),
      ctaType: handleNestedProp(data, 'data.ctaType')
    };
  };
  Header350.applyDarkTheme = function applyDarkTheme(itemTheme, theme) {
    return itemTheme === 'dark' ? theme[itemTheme] : '';
  };
  Header350.renderParagraph = function renderParagraph(theme, componentTheme, paragraph, disclaimerData) {
    if ((0, _isEmpty2["default"])(paragraph)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.bodyCopy + " " + _header["default"].paragraph + " " + _header["default"].marginIntermediate
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: paragraph
      }),
      disclaimerData: disclaimerData
    }));
  };
  Header350.renderHeadline = function renderHeadline(theme, mainHeading, headingTag, disclaimerData) {
    if ((0, _isEmpty2["default"])(mainHeading)) {
      return '';
    }
    return /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: headingTag || 'h1',
      text: mainHeading,
      className: theme.headingOne + " " + _header["default"].marginIntermediate + " " + _header["default"].mainHeader + " " + _header["default"].headline,
      disclaimerData: disclaimerData
    });
  };
  var _proto = Header350.prototype;
  _proto.render = function render() {
    var _clsx;
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var mainHeading = componentData.mainHeading,
      headingTag = componentData.headingTag,
      textAlignment = componentData.textAlignment,
      paragraph = componentData.paragraph,
      componentTheme = componentData.theme,
      disclaimerData = componentData.disclaimerData,
      withBreadCrumb = componentData.withBreadCrumb;
    var renderedHeadline = Header350.renderHeadline(theme, mainHeading, headingTag, disclaimerData);
    var renderedParagraph = Header350.renderParagraph(theme, componentTheme, paragraph, disclaimerData, textAlignment);
    var alignmentClasses = theme['col-sm-offset-1'] + " " + _header["default"].leftAligned;
    if (textAlignment) {
      var alignment = textAlignment.toLowerCase();
      if (alignment === 'right') {
        alignmentClasses = theme['col-sm-offset-3'] + " " + _header["default"].rightAligned;
      } else if (alignment === 'center') {
        alignmentClasses = theme['col-sm-offset-2'] + " " + _header["default"].centerAligned;
      }
    }

    // Check there is anything to even render
    if ((0, _isEmpty2["default"])(renderedHeadline) && (0, _isEmpty2["default"])(renderedParagraph)) {
      return '';
    }
    // Either headline or message is not empty so render the component
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _header["default"].header350 + " " + (componentTheme !== undefined ? theme[componentTheme] : ''),
      automation: "header-350"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(theme.row, _header["default"].innerHeader350, (_clsx = {}, _clsx[_header["default"].withBreadCrumb] = withBreadCrumb, _clsx))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-8'] + " " + alignmentClasses + " " + _header["default"].headline,
      style: textAlignment ? {
        textAlign: textAlignment
      } : {}
    }, renderedHeadline, renderedParagraph, componentData.link && componentData.link.url && componentData.link.url.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: Header350.applyDarkTheme(componentTheme, theme)
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      "data-section": mainHeading,
      data: Header350.ctaData(handleNestedProp(componentData, 'componentData.link')),
      classes: [Header350.applyDarkTheme(componentTheme, theme) + " " + (componentData.link.priority === 'lowIcon' ? _header["default"].adjustIconPosition : '')]
    })))));
  };
  return Header350;
}(_react["default"].Component);
Header350.displayName = 'Header350';
Header350.defaultProps = {
  data: _header2["default"],
  defaultData: _header2["default"],
  theme: {}
};